import { render, staticRenderFns } from "./programTable.vue?vue&type=template&id=a4032a66&scoped=true"
import script from "./programTable.vue?vue&type=script&lang=js"
export * from "./programTable.vue?vue&type=script&lang=js"
import style0 from "./programTable.vue?vue&type=style&index=0&id=a4032a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4032a66",
  null
  
)

export default component.exports